import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5284fcec")

_pushScopeId("data-v-5284fcec")
const _hoisted_1 = {
  key: 0,
  id: "container"
}
const _hoisted_2 = { class: "profile-email" }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Facebook")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_7 = {
  key: 1,
  class: "spin"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_toolbar = _resolveComponent("toolbar")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_datetime = _resolveComponent("ion-datetime")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_toolbar, {
        title: _ctx.$tr($setup.trProfile, 'profile'),
        backbutton: true
      }, null, 8, ["title"]),
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withId(() => [
          ($data.profile)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode("form", {
                  onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($options.handleSave && $options.handleSave(...args)), ["prevent"]))
                }, [
                  _createVNode("div", _hoisted_2, [
                    _createVNode("p", _hoisted_3, _toDisplayString($data.profile.fullName), 1),
                    _createTextVNode(" " + _toDisplayString($data.profile.email) + " ", 1),
                    ($data.profile.banda)
                      ? (_openBlock(), _createBlock("p", _hoisted_4, [
                          _createVNode(_component_ion_text, { color: "gold" }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString($data.profile.banda), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_ion_item, { class: "not-opacity-disabled" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_label, { position: "floating" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$tr($setup.trProfile, 'birthday')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_datetime, {
                        disabled: !!$data.profile.birthDate,
                        "display-format": "DD.MM.YYYY",
                        "display-timezone": "JST",
                        modelValue: $data.profile.birthDate,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($data.profile.birthDate = $event)),
                        id: "birthday"
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap ion-text-start" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$tr($setup.trProfile, 'birthdayCheck')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_checkbox, {
                        modelValue: $data.profile.receiveOffersToBirthday,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($data.profile.receiveOffersToBirthday = $event)),
                        id: "isBirthdaySubscribe"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_label, { position: "floating" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$tr($setup.trProfile, 'city')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        modelValue: $data.profile.city,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($data.profile.city = $event)),
                        id: "city"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap ion-text-start" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$tr($setup.trProfile, 'cityCheck')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_checkbox, {
                        modelValue: $data.profile.receiveOffersByLocation,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($data.profile.receiveOffersByLocation = $event)),
                        id: "isCitySubscribe"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_label, { position: "floating" }, {
                        default: _withId(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        modelValue: $data.profile.facebookUrl,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($data.profile.facebookUrl = $event)),
                        id: "facebook"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    disabled: $data.loading,
                    expand: "block",
                    type: "submit",
                    color: "shiawasedo"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: $setup.save
                      }, null, 8, ["icon"]),
                      _hoisted_6,
                      (!$data.loading)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.$tr($setup.trProfile, 'save')), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$tr($setup.trSignIn, 'loading')), 1)
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 32)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_ion_spinner, { name: "circles" })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})